<template>
  <div>
    <a-modal class="playerModal" :closable="false" :title="$t('playerModalTitle')" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <div class="player-list">
        <div
          :class="['player-item', item.checked ? 'active' : '']"
          v-for="item in playerList"
          :key="item.id"
          @click="handleClick(item)"
        >
          <div class="icon">
            <img :src="item.icon" alt="" />
          </div>
          <span>{{ item.name }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'PlayerModal',
  props: {
    playerList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      ModalText: 'Content of the modal'
    }
  },
  mounted() {},
  methods: {
    handleOk() {
      this.$emit('selectPlayer', this.selectPlayer)
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    handleClick(item) {
      this.playerList.forEach(item => {
        item.checked = false
      })
      this.selectPlayer = item
      item.checked = true
      console.log(this.selectPlayer)
    }
  }
}
</script>

<style lang="less" scoped>
.player-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .player-item {
    width: calc(100% / 5);
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 4px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      transition: filter 0.3s ease;
      &:hover {
        cursor: pointer;
        filter: sepia(100%) saturate(400%) brightness(100%) hue-rotate(0deg);
      }
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      margin-top: 8px;
    }
    .icon {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      background-color: #f4f4f4;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .active {
    span {
      color: #ff6d00;
    }
    .icon {
      border: solid 1px #ffb829;
    }
    img {
      filter: sepia(100%) saturate(400%) brightness(100%) hue-rotate(0deg);
    }
  }
}
</style>
<style lang="less">
.playerModal {
  .ant-modal-content {
    background: url('~@/assets/img/bj_player@2x.png') no-repeat;
    background-size: 100% 100%;
  }
  .ant-modal-header {
    background: transparent;
    border-bottom: none;
    padding: 16px 50px;
    padding-top: 30px;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
}
</style>
